/** @jsxImportSource theme-ui */
import React from 'react';

import { Typography } from 'components/_common/Typography';
import BdPngExportHeader from 'components/_controls/PngExports/BdPngExportHeader';

import RiskOverviewCardDisruptionDetails from 'riskOverview/components/RiskOverviewCardDisruptionDetails';

import RiskOverviewBepiExportContainer from '../RiskOverviewBepiExportContainer';
import RiskOverviewCardPortraitContainer from './RiskOverviewCardPortraitContainer';

type RiskOverviewCardDisruptionPortraitProps = {
  header: string;
  locationId: number;
  activityId: number;
};

const RiskOverviewCardDisruptionPortrait: React.FC<RiskOverviewCardDisruptionPortraitProps> = ({
  header,
  locationId,
  activityId,
}) => {
  return (
    <RiskOverviewCardPortraitContainer>
      <BdPngExportHeader title={header} superTitle="Your risk of" supertitleVariant="overline" />
      <Typography variant="h6" color="stone90" marginBottom="32px" sx={{ mt: '16px' }}>
        Risk of Disruption
      </Typography>
      <RiskOverviewCardDisruptionDetails
        locationId={locationId}
        diseaseActivityId={activityId}
        hideBepi
        sx={{
          '& .ro-disruption-panel-container': {
            pb: '24px',
            mb: '48px',
            '& .ro-card-disrupt-factor-container': {
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              columnGap: '32px',
              '& .icon-column': { width: '100%', mr: 0, pb: 0, gridColumn: '1' },
              '& .detail-column': { width: '100%', ml: 0, gridColumn: '2 / span 2' },
            },
          },
        }}
      />
      <RiskOverviewBepiExportContainer
        locationId={locationId}
        sx={{
          '& .bepi-stats': {
            mt: '24px',
            '& .vulnerability-statement-container': { gridColumn: '1 / span all' },
            '& .icon-container': { gridColumn: '1 / span all' },
          },
        }}
      />
    </RiskOverviewCardPortraitContainer>
  );
};

export default RiskOverviewCardDisruptionPortrait;
